import { Fragment, useCallback } from 'react';
import { IconButton } from '@material-ui/core';
import { Sync as SyncIcon } from '@material-ui/icons';

const MockFn = () => {};

/**
 * @param {{
 *    title: string;
 *    type: 1 | 2 | 3;
 *    loading: boolean;
 *    hideRefresh: boolean;
 *    onRefresh: () => void;
 * }} props 
 * @returns {React.JSX.Element}
 */
export const PageTitle = ({
  title,
  type,
  loading,
  hideRefresh = false,
  onRefresh: _handleRefresh,
}) => {
  const handleRefresh = useCallback(() => {
    if (loading) {
      return MockFn;
    }
    _handleRefresh();
    return MockFn;
  }, [loading, _handleRefresh]);

  const RefreshButton = ({
    className
  }) => {
    if (hideRefresh) {
      return <Fragment />;
    }

    return (
      <IconButton
        size='small'
        className={className}
        onClick={handleRefresh}
      >
        <SyncIcon fontSize='small' className={loading && 'animate-spin'} />
      </IconButton>
    );
  };

  const CollectionA = () => (
    <div className='tasks-page-heading page-header height-56 flex align-items-center justify-content-center p-l-6 p-r-6 border-top-1-light-grey border-bottom-1-light-grey'>
      <div className='flex align-items-center gap-8'>
        <p className='page-heading font-proxima-nova font-24 bold'>{title}</p>
        <RefreshButton className='primary-button' />
      </div>
    </div>
  );

  const CollectionB = () => (
    <div className='tasks-page-heading page-header flex align-items-center height-40 p-l-6 p-r-6'>
      <div className='bg-lighter-grey height-40 flex flex-fill align-items-center justify-content-center p-l-6 p-r-6'>
        <div className='flex align-items-center gap-8'>
          <span className='bold transform-uppercase tracking-wider'>{title}</span>
          <RefreshButton className='' />
        </div>
      </div>
    </div>
  );

  const CollectionC = () => (
    <div className='tasks-page-heading page-header flex align-items-center height-40 p-l-6 p-r-6'>
      <div className='bg-dark-primary-v2 height-40 flex flex-fill align-items-center justify-content-center p-l-6 p-r-6'>
        <div className='flex align-items-center gap-8'>
          <span className='color-white bold transform-uppercase tracking-wider'>{title}</span>
          <RefreshButton className='white-button' />
        </div>
      </div>
    </div>
  );

  const UIItemCollection = new Map([
    [1, CollectionA],
    [2, CollectionB],
    [3, CollectionC],
  ]);

  const UIItem = UIItemCollection.get(type) || CollectionC

  return <UIItem />;
};

export default PageTitle;
